// extracted by mini-css-extract-plugin
module.exports = {"tableDetail":"InvoiceEdit_tableDetail__2B0sE","stickyFooter":"InvoiceEdit_stickyFooter__2OxUg","dragMenu":"InvoiceEdit_dragMenu__16s-8","draggable":"InvoiceEdit_draggable__2q709"};